<template>
    <div class="d-flex flex-column vh-100 p-2 bg-dark text-white">
        <div class="d-flex flex-row align-items-stretch justify-content-center" style="flex: 1">
            <div class="justify-content-center w-100">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
    }
</script>
